import i18n from "@/i18n"; // 引入 I18n 套件
export const main = {
    install(Vue, option) {
        i18n.init(option.config).then(oI18n => {
            // **************** 區域
            const belongs = ['Andy Chui', 'Andy Tse', 'Anthony Lau', 'Calvin Wong', 'Ceci Chan', 'Clovis Chang', 'Cyrus Hui', 'Cyrus Yan', 'Dennis Pang', 'Jacky Yeung', 'Kelvis Yim', 'Kenny Kwong', 'Kim Chan', 'Law Suk Ming', 'Lincoln Tzan', 'Paggie Law', 'Winnie Wong'];
            const belongOptions = belongs.map(key => {
                return { value: key, text: key };
            });
            Vue.prototype.$belongOptions = belongOptions;

            // **************** 職級
            const joinClasses = ['non_managerial', 'ADM', 'DM', 'SDM', 'BM', 'SBM', 'DD', 'SDD', 'EDD'];
            const joinClassOptions = joinClasses.map(key => {
                return { value: key, text: oI18n.t(`jobClassOptions.${key}`) };
            });
            Vue.prototype.$joinClassOptions = joinClassOptions;
        })
    }
}

export const excludeMenuList = ['requirement', 'student-requirement', 'online-course', 'blog', 'student-blog', 'video', 'setting-requirement', 'enquiry'];
export const gradeList = ['P1', 'P2', 'P3', 'P4'];